import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import MemberRow, { DragHandle } from './MemberRow';
import arrayMove from 'array-move';

// Reuses react-sortable-hoc (already a dependency, used elsewhere) so reordering
// matches the app's existing drag patterns. onSortEnd → PATCH /reorder (1-based).
const Handle = SortableHandle(() => <DragHandle />);

const SortableItem = SortableElement(({ member, onOpen }) => (
  <MemberRow member={member} onOpen={onOpen} dragHandle={<Handle />} />
));

const SortableList = SortableContainer(({ members, onOpen }) => (
  <Box>
    {members.map((member, index) => (
      <SortableItem key={member.id} index={index} member={member} onOpen={onOpen} />
    ))}
  </Box>
));

const MemberGroup = ({ title, members, onOpen, onReorder, parentLimitReached }) => {

  const [list, setList] = useState([])

  useEffect(() => {
    setList(members.sort((a, b) => a.position - b.position))
  }, [members])

  return (
    <Box mb={3}>
      <Text
        fontFamily="Poppins"
        fontWeight={600}
        fontSize="13px"
        color="mutedText"
        mb={2}
        sx={{ textTransform: 'none' }}
      >
        {title}
      </Text>
      <SortableList
        members={list}
        onOpen={onOpen}
        useDragHandle
        lockAxis="y"
        helperClass="ft-sortable-helper"
        onSortEnd={({ oldIndex, newIndex }) => {
          if (oldIndex === newIndex) return;
          const next = arrayMove(list, oldIndex, newIndex);
          const updatedList = next.map((ch, index) => ({ ...ch, position: index }))
          setList(updatedList)
          onReorder(members[oldIndex], newIndex + 1); // position is 1-based
        }}
      />
    </Box>
  );
};

MemberGroup.propTypes = {
  title: PropTypes.string.isRequired,
  members: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onOpen: PropTypes.func,
  onReorder: PropTypes.func,
  parentLimitReached: PropTypes.bool,
};

MemberGroup.defaultProps = {
  onOpen: null,
  onReorder: () => { },
  parentLimitReached: false,
};

export default MemberGroup;
